import { FilterMatchMode } from 'primereact/api';

export const RolUsuarioModel = {
    nombre: {
        header: 'Roles disponibles',
        table: true,
        sort: true,
        filter: true,
        matchMode: FilterMatchMode.CONTAINS,
        filterPlaceholder: 'Filtrar por nombre',
        style: { width: '50%' },
    },
    fecha: {
        header: 'Fecha de asignación',
        table: true,
        sort: true,
        filter: false,
        isDate: true,
        style: { width: '30%', textAlign: 'center' }
    },
    asignado: {
        header: 'Asignar / Quitar',
        table: true,
        isBoolean: true,
        filter: true,
        style: { width: '20%', textAlign: 'center' },
        bodyTemplate: 'columnaAsignar' // Nombre del template que resolverá TablaDinamica
    }
};